import { combineReducers } from 'redux';
import SystemSettingsReducer from "./SystemSettings";
import popup from './popup';
import DocumentReducer from './DocumentReducer';
import CommandsReducer from './CommandsReducer';

const reducers = combineReducers({
  
  popup,
  DocumentReducer,
  SystemSettingsReducer,
  CommandsReducer
  
})


export default reducers;